import React, { useState, useContext, useRef, useEffect } from "react";
import { IoClose } from "react-icons/io5";
import "../assets/css/component-modal-send-code.css";
import { ThemeContext } from "../contexts/ThemeContext";
import { AuthContext } from "../contexts/AuthContext";
import { WorkspaceContext } from "../contexts/WorkspaceContext";
import { socket } from "../services/socket";
import { sendMessageAccessCodeInbox } from "../services/sendMessageInbox";
import { sendMessageAccessCodeGroupe } from "../services/sendMessageGroupe";
import Person from "./Person";

export default function ModalSendCode(props) {
  const { showCodeOrLink, setShowCodeOrLink, accessCode } = props;
  const { user } = useContext(AuthContext);
  const { currentWorkspace } = useContext(WorkspaceContext);
  const workspaceId = currentWorkspace?._id;
  const { theme } = useContext(ThemeContext);
  const [destinataires, setDestinataires] = useState([]);
  const [disabled, setDisabled] = useState(true);
  const [receivers, setReceivers] = useState([]);
  const [activeTab, setActiveTab] = useState("Contacts");
  const [sent, setSent] = useState(false);
  const modalSendCode = useRef(null);

  const getReceivers = (type) => {
    setActiveTab(type);
    socket.emit("get_contacts_and_groups_from_modal", type, workspaceId, (res) => {
      setReceivers(res || []);
    });
  };

  // Charger les contacts automatiquement à l'ouverture
  useEffect(() => {
    getReceivers("Contacts");
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        modalSendCode.current &&
        !modalSendCode.current.contains(event.target) &&
        !event.target.closest(".modal__send__code__content")
      ) {
        setShowCodeOrLink(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Quand on change de tab, réinitialiser la sélection
  const handleTabChange = (type) => {
    setDestinataires([]);
    setDisabled(true);
    getReceivers(type);
  };

  const handleSend = () => {
    if (activeTab === "Contacts") {
      sendMessageAccessCodeInbox({
        receivers: destinataires,
        user,
        accessCode,
      }, workspaceId);
    } else {
      // Pour les groupes, envoyer un seul message de groupe dans chaque canal sélectionné
      destinataires.forEach((groupe) => {
        sendMessageAccessCodeGroupe({
          roomId: groupe.roomId,
          membres: groupe.membres,
          user,
          accessCode,
          workspaceId,
        });
      });
    }
    setSent(true);
    setShowCodeOrLink(false);
  };

  return (
    <>
      <div
        className="modal__send__code"
        style={{
          visibility: showCodeOrLink ? "visible" : "hidden",
          opacity: showCodeOrLink ? 1 : 0,
        }}
      >
        <div
          ref={modalSendCode}
          className="animate__animated animate__bounceIn animate__fast modal__send__code__content"
          style={{
            backgroundColor: theme === "light" ? "#213861ff" : "#f8f8f8",
          }}
        >
          <button
            className="btn__modal__send__close border-none"
            onClick={() => {
              setShowCodeOrLink(false);
            }}
          >
            <IoClose />
          </button>
          <div className="modal__send__code__header">
            <h3
              style={{
                color: theme === "light" ? "#f8f8f8" : "#0256cd",
              }}
            >
              {activeTab === "Contacts"
                ? "Les personnes à qui vous souhaitez transférer le code."
                : "Envoyer le code à tous les membres d'un groupe."}
            </h3>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-around",
              }}
            >
              <button
                className={`btn__switch__modal__send__code border-none`}
                onClick={() => handleTabChange("Contacts")}
                style={{
                  backgroundColor: activeTab === "Contacts"
                    ? (theme === "light" ? "#062147" : "#0256cd")
                    : (theme === "light" ? "#f8f8f8" : "transparent"),
                  color: activeTab === "Contacts"
                    ? "#f8f8f8"
                    : "#0256cd",
                  border: activeTab !== "Contacts" ? "1px solid #0256cd" : "none",
                }}
              >
                Contacts
              </button>
              <button
                className={`btn__switch__modal__send__code border-none`}
                onClick={() => handleTabChange("Groupes")}
                style={{
                  backgroundColor: activeTab === "Groupes"
                    ? (theme === "light" ? "#062147" : "#0256cd")
                    : (theme === "light" ? "#f8f8f8" : "transparent"),
                  color: activeTab === "Groupes"
                    ? "#f8f8f8"
                    : "#0256cd",
                  border: activeTab !== "Groupes" ? "1px solid #0256cd" : "none",
                }}
              >
                Groupes
              </button>
            </div>
          </div>
          <ul className="modal__send__code__content__ul__list">
            {receivers.map((rcv, idx) => (
              <li
                key={idx + "__" + (rcv.id || "").split("").reverse().join("")}
                id={(rcv.id || "").split("").reverse().join("")}
              >
                <label
                  htmlFor={`input__ckeckbox__send__code__modal__${rcv.nom}___id__${idx}`}
                  className="modal__send__code__item"
                >
                  <div className="modal__send__code__avatar">
                    <Person
                      person={{
                        image: rcv.isGroupe ? rcv.imageUrl : rcv.userImage,
                        nom: rcv.nom || "",
                        prenom: rcv.isGroupe ? rcv.nom : rcv.prenom,
                        userId: rcv.id,
                        colors: rcv.color,
                      }}
                    />
                  </div>
                  <span
                    className="modal__send__code__name"
                    style={{
                      color: theme === "light" ? "#f8f8f8" : "#0256cd",
                    }}
                  >
                    {rcv.isGroupe
                      ? rcv.nom
                      : rcv.prenom + " " + rcv.nom}
                    {rcv.isGroupe && rcv.membres && (
                      <span style={{ fontSize: "12px", opacity: 0.7, marginLeft: "6px" }}>
                        ({rcv.membres.length} membres)
                      </span>
                    )}
                  </span>
                  <input
                    className="modal__send__code__checkbox"
                    type="checkbox"
                    name={`input__ckeckbox__send__code__modal__${rcv.nom}___name__${idx}`}
                    id={`input__ckeckbox__send__code__modal__${rcv.nom}___id__${idx}`}
                    onChange={(evt) => {
                      let peers = [...destinataires];
                      if (evt.target.checked) {
                        peers.push(receivers[idx]);
                      } else {
                        peers = peers.filter(
                          (peer) => peer.id !== receivers[idx].id
                        );
                      }
                      peers.length > 0
                        ? setDisabled(false)
                        : setDisabled(true);
                      setDestinataires(peers);
                    }}
                  />
                </label>
              </li>
            ))}
          </ul>
          <div className="modal__send__code__footer">
            <button
              className="btn__modal__send__code__send border-none"
              disabled={disabled || sent}
              onClick={handleSend}
              style={{
                backgroundColor: disabled
                  ? "#888383"
                  : theme === "light"
                  ? "#f8f8f8"
                  : "#0256cd",
                color: theme === "light" ? "#0256cd" : "#f8f8f8",
              }}
            >
              {sent ? "Envoyé !" : "Envoyer"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
